
// FAQView.jsx
import React from 'react';
import {
  Box,
  Container,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useNavigate } from 'react-router-dom';



const faqs = [
  {
    question: '¿Qué es cardex Medico?',
    answer:
      'Es una solución digital que transforma la gestión de la información clínica, impulsando la eficiencia, la precisión y, en última instancia, la calidad del cuidado del paciente.',
  },
  {
    question: '¿Mis datos personales están seguros?',
    answer:
      'La información general que los usuarios proporcionen solo será usada para personalizar los'+
' servicios de la misma, para ofrecer publicidad adecuada, y para canalizar promociones publicitarias de manera personalizada. Para'+
' mayor información sobre la privacidad de los Datos Personales y casos en los que será revelada, se pueden consultar nuestras'+
' Políticas de Privacidad.',
  },
  {
    question: '¿Puedo acceder a mi información desde cualquier dispositivo?',
    answer:
      'Para hacer uso de la App, necesitará un Dispositivo móvil (teléfono celular inteligente, Tablet o computadora) que cumpla con los requisitos de compatibilidad y de sistema, que tenga una conexión a Internet que funcione y cuente con el software compatible.',
  },
  {
    question: '¿Necesito instalar algo para usar el sistema?',
    answer:
      'Para usar una app o web, se necesita un dispositivo (computadora, teléfono o tableta) '+
      'con un navegador (para apps web) o el sistema operativo (para apps móviles), una conexión a internet (generalmente), '+
      'y una cuenta de usuario (si es necesaria). El dispositivo debe cumplir con los requisitos mínimos de sistema de la aplicación o página.',
  },
  {
    question: '¿Qué hago si olvidé mi contraseña?',
    answer:
      'Ve a la sección de “Recuperar Contraseña” en la pantalla de inicio de sesión y sigue las instrucciones que enviamos a tu correo electrónico.',
  },
];

export default function FAQ() {
  const navigate = useNavigate();

  return (
    <Box component="main">
      {/* Hero Section */}
      <Box
        sx={{
          py: 20,
          textAlign: 'center',
          color: 'black',
          background: 'url(/images/faq-hero.jpg) center/cover no-repeat',
        }}
      >
        <Container maxWidth="sm">
          <Typography variant="h3" gutterBottom>
            Preguntas Frecuentes
          </Typography>
          <Typography variant="h6">
            Encuentra respuestas rápidas a las dudas más comunes sobre nuestra plataforma médica.
          </Typography>
        </Container>
      </Box>

      {/* FAQ Section */}
      <Container sx={{ py: 8 }}>
        {faqs.map((faq, index) => (
          <Accordion key={index} sx={{ mb: 2 }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="h6">{faq.question}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body1" color="text.secondary">
                {faq.answer}
              </Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Container>

      {/* CTA Section */}
      <Box sx={{ py: 8, textAlign: 'center', backgroundColor: 'grey.100' }}>
        <Container>
          <Typography variant="h5" gutterBottom>
            ¿No encontraste la respuesta que buscabas?
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            Contáctanos y con gusto te ayudaremos a resolver tus dudas.
          </Typography>
          <Button
            variant="contained"
            size="large"
            color="primary"
            onClick={() => navigate('/contact-us')}
          >
            Contáctanos
          </Button>
        </Container>
      </Box>
    </Box>
  );
}
